import React from "react";
import './VisionMissionSection.css';  // Import the external CSS file

const VisionMissionSection = () => {
  return (
    <div className="vision-mission-section">
      {/* Left Section: Our Vision */}
      <div className="section">
     
        <p>
        Maniraj Builder is led by  <strong>Mr. Arvind Kumar Singh</strong>, a dynamic and ethical entrepreneur with a down-to-earth approach. His vision is to make homeownership accessible to everyone by offering cost-effective housing with all essential facilities. Under his leadership, we are committed to delivering projects that exceed customer expectations.

        </p>
        
      </div>

      {/* Right Section: Our Mission */}
  
    </div>
  );
};

export default VisionMissionSection;
